import { PermissionKey } from "~/types/Permissions";

export const hasPermissionForNameWithTypeCheck = (
  name: string,
  hasPermission: (key: PermissionKey) => boolean,
) => {
  const value = (name || "").toLowerCase().trim();

  if (value === "зона сервиса")
    return hasPermission("ivideonGroups.acceptGroup.service");

  if (value === "зона продаж")
    return hasPermission("ivideonGroups.acceptGroup.sale");

  return true;
};
